import { captureException } from '@sentry/nuxt';

export default defineNuxtPlugin({
  name: 'check-availability',
  parallel: true,
  setup() {
    const { isApiAvailable } = useSiteAvailability();
    const { apiBase } = useDomainConfig();

    void checkAvailability(apiBase).then((isAvailable) => {
      isApiAvailable.value = isAvailable;

      if (!isAvailable) {
        captureException(new Error('Не можем достучаться до сервера'));
      }
    });
  },
});

type THealthResponse = {
  code: number
  message: string
  data: unknown
}

async function checkAvailability(apiBase: string) {
  try {
    const response = await $fetch<THealthResponse>(`${apiBase}/api/health`);
    return response.code === 200;
  } catch {
    return false;
  }
}
